import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { iFullStoreState } from '../../../../shared/interfaces';
import { fetchDevicesLatestPing } from '../../../../stores/reducers/devicesData/AC';
import { openDashboard } from '../../../../stores/reducers/dashboardInfo/AC';
import DashboardBlock from '../../../DashboardBlock';
import Loader from '../../Billing/Other/Loader';
import { ReportNavbar } from '../ReportNavbar';
import ServiceNeededTable from './ServiceNeededTable';
import { useServiceNeededReport } from './hooks/useServiceNeededReport';
import { exportServiceReportXlsx } from './exports';
import styles from './ServiceNeeded.module.scss';
import MinimalTile from '../../../general/MinimalTile';
import { Tooltip } from '@mui/material';
import { Fa } from '../../../elements/fa';
import { faFileExcel } from '@fortawesome/fontawesome-free-solid';

type FiltersType = {
    [type: string]: { [id: string]: true }
};

const ServiceNeededReport = memo(() => {
    const dispatch = useDispatch();
    const filters = useSelector<iFullStoreState, FiltersType>(state => state.report.details.filters);

    const [filteredDeviceIds, setFilteredDeviceIds] = useState<string[]>([]);

    useEffect(() => {
        dispatch(fetchDevicesLatestPing());
        dispatch(openDashboard());
    }, [dispatch]);

    useEffect(() => {
        const deviceIds = filters['device'] ? Object.keys(filters['device']) : [];
        setFilteredDeviceIds(deviceIds);
    }, [filters]);

    const { reportData, loading } = useServiceNeededReport(filteredDeviceIds);

    const hasData = reportData && (reportData.expired.length > 0 || reportData.days30.length > 0);

    return (
        <DashboardBlock>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', marginBottom: '12px', whiteSpace: 'nowrap' }}>
                <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>Service Needed Report</h2>
                {hasData && !loading && (
                    <Tooltip title="Export as XLSX">
                        <button onClick={() => exportServiceReportXlsx(reportData!)} className={styles.exportBtn}>
                            <Fa icon={faFileExcel} /> Export
                        </button>
                    </Tooltip>
                )}
            </div>
            <ReportNavbar />

            {loading ? (
                <Loader />
            ) : hasData ? (
                <div className={styles.reportContainer}>
                    <ServiceNeededTable data={reportData!} />
                </div>
            ) : (
                <MinimalTile className={styles.minimalTile}>
                    <p>No services needed found for the vehicles.</p>
                </MinimalTile>
            )}
        </DashboardBlock>
    );
});

export default ServiceNeededReport;